module.exports = __webpack_public_path__ + "static/img/index-04.933095b6.png";